module.exports = __webpack_public_path__ + "static/media/banner_01_lg.02ae4cc5.jpg";